import { useFeatureIsOn } from '@growthbook/growthbook-react';

export const WELLHUB_CLUB_FLAG = 'partners.acquisition.wellhub-club' as const;

export function useWellhubClub(): boolean {
  return useFeatureIsOn(WELLHUB_CLUB_FLAG);
}

export function useShowWellhubClub(): boolean {
  return useWellhubClub();
}
